import { BiLinkExternal } from 'react-icons/bi';
import { MdCall, MdEmail } from 'react-icons/md';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import { ReactComponent as DefaultLogoIcon } from 'images/icons/inspiretec_white_logo.svg';
import { DEFAULT_SECONDARY_COLOUR } from 'shared/constants/styleConstants';
import Text from '../typography/Text';
import PageContentContainer from './PageContentContainer';

const getWebsiteUrl = (website) => {
  if (!website) {
    return '';
  }

  return website.match('^http') ? website : `https://${website}`;
};

export default function Footer() {
  const { whiteLabelSettings } = useWhiteLabelSettings();

  const {
    primaryColour,
    copyrightMessage = '',
    email = '',
    phoneNumber = '',
    website = '',
    overviewLogo = '',
  } = whiteLabelSettings;

  const iconColor = primaryColour;

  return (
    <PageContentContainer
      style={{ backgroundColor: primaryColour || DEFAULT_SECONDARY_COLOUR }}
    >
      <div className="px-4 pb-2">
        <div className="mt-8 mb-14 flex flex-col lg:flex-row lg:mb-10 lg:justify-between lg:items-center">
          <div>
            {overviewLogo ? (
              <img src={overviewLogo} className="max-h-12" alt="logo" />
            ) : (
              <DefaultLogoIcon className="h-10" />
            )}
          </div>
          <div className="flex flex-col lg:flex-row">
            {phoneNumber && (
              <div className="mr-9 mt-6 flex items-center lg:mt-0">
                <div
                  style={{ color: iconColor }}
                  className="mt-1 mr-2 text-2xl lg:mt-0"
                >
                  <MdCall />
                </div>
                <Text className="text-white">{phoneNumber}</Text>
              </div>
            )}
            {email && (
              <div className="mr-9 mt-5 flex items-center lg:mt-0">
                <div
                  style={{ color: iconColor }}
                  className="mt-1 mr-2 text-2xl lg:mt-0"
                >
                  <MdEmail />
                </div>
                <a
                  className="text-white underline underline underline-offset-[6px] decoration-solid"
                  href={`mailto:${email}`}
                >
                  {email}
                </a>
              </div>
            )}
            {website && (
              <div className="mr-0 mt-5 flex items-center lg:mt-0">
                <div
                  style={{ color: iconColor }}
                  className="mt-1 mr-2 text-2xl lg:mt-0"
                >
                  <BiLinkExternal />
                </div>
                <a
                  rel="noreferrer"
                  target="_blank"
                  className="text-white underline underline underline-offset-[6px] decoration-solid"
                  href={getWebsiteUrl(website)}
                >
                  {website}
                </a>
              </div>
            )}
          </div>
        </div>
        <Text className="text-white py-4 border-t border-white/[.1]">
          {copyrightMessage}
        </Text>
      </div>
    </PageContentContainer>
  );
}
